<template>
	<div class="ss-content volunteer-home-content lhc-content" :class="['lhc-content-' + $route.name]">
		<div class="ss-container">
			<div class="ss-container__left_small">
				<ul class="volunteer-types">
					<li class="volunteer-types__title">大兴非遗</li>
					<li v-for="(item, index) in typeList" :class="{active: typeIndex === index}" @click="changeType(item.value)" :key="index">{{item.label}}</li>
				</ul>
			</div>
			<div class="ss-container__right_big">
				<div class="ss-container__right_top">
					{{title_}}
					<img src="../../assets/img/lhc/feiyi.png" class="feiyi-img1" />
					<div class="lchIntro-only" :class="{'lchIntro-only-open': $route.name === 'lchIntro'}">
						<img src="../../assets/img/lhc/title-zs.png" class="feiyi-img2" />
<!--						<div class="intro-text">非遗介绍文案请详细说明非遗介绍文案请详细说明非遗介绍文案请详细说明非遗介绍文案请详细说明非遗介绍文案请详细说明非遗介绍文案请详细说明非遗介绍文案请详细说明</div>-->
					</div>
				</div>
				<div class="ss-container__right_bottom">
					<router-view />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				typeIndex: 0,
				typeList: [{
					exp: ['lchIntro', 'lchIntroDetail'],
					value: 'lchIntro',
					label: '非遗介绍'
				}, {
					exp: ['lchPublicity', 'lchPublicityDetail'],
					value: 'lchPublicity',
					label: '非遗公示'
				}, {
					exp: ['lchPolicy', 'lchPolicyDetail'],
					value: 'lchPolicy',
					label: '非遗项目方针政策'
				}, {
					exp: ['lchProtect', 'lchProtectDetail'],
					value: 'lchProtect',
					label: '非遗传承保护'
				}]
			}
		},
		computed:{
			title_() {
				return this.typeList[this.typeIndex].label
			}
		},
		watch: {
			'$route.path': {
				handler: function(val, oldVal){
					this.typeIndex = this.typeList.findIndex(o => o.exp.findIndex(o1 => o1 === this.$route.name) !== -1);
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			changeType(name) {
				this.$route.name !== name && this.$router.replace({
					name: name
				})
			}
		}
	}
</script>

<style lang="scss">
	@import '~@/views/volunteerHome/css/volunteer-home.scss';
	.lhc-content{
		/* 右侧内容区占满栏宽，避免嵌套路由根节点宽度异常 */
		.ss-container__right_bottom{
			width: 100%;
		}
		&.lhc-content-lchIntro{
			.ss-container__right_top{
				min-height: 297px;
				.feiyi-img1{
					top: 126px;
					right: 835px;
				}
			}
		}
		.lchIntro-only{
			opacity: 0;
			height: 0;
			overflow: hidden;
			@include tst();
			@include abs(0, 0);
			width: 0;
			&.lchIntro-only-open{
				height: 100%;
				width: 748px;
				opacity: 1;
			}
		}
		.ss-container__right_top{
			.feiyi-img1{
				@include tst();
				@include abs(25px, 43px);
				width: 112px;
				display: block;
			}
			.feiyi-img2{
				@include abs(0, 520px);
				width: 228px;
				display: block;
			}
			.intro-text{
				@include abs(0, 0);
				padding: 64px 48px;
				width: 520px;
				font-size: 18px;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 30px;
			}
		}
	}
	.volunteer-types{
		li{
			&::after{
				content: '';
				@include abs(null, 15px, 0, 15px);
				background-color: #DEDEDE;
				height: 1px;
			}
			&:last-child::after, &:first-child::after{
				display: none;
			}
		}
	}
</style>
